// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-custom {
  background-color: var(--bg-color);
  color: var(--text-color);
  width: 100%;
  padding: var(--padding) !important;
}

.btn-custom:hover {
  background-color: var(--hover-bg-color);
  color: var(--hover-text-color);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/button/button.component.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,wBAAA;EACA,WAAA;EACA,kCAAA;AACJ;;AAEA;EACI,uCAAA;EACA,8BAAA;AACJ","sourcesContent":[".btn-custom {\n    background-color: var(--bg-color);\n    color: var(--text-color);\n    width: 100%;\n    padding: var(--padding) !important;\n}\n\n.btn-custom:hover {\n    background-color: var(--hover-bg-color);\n    color: var(--hover-text-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
